import module from 'module';
import StatusBasedService from "./statusBasedService";

module.factory('userCounterService', (statusService) =>
  new StatusBasedService({
    property: 'userCounter',
    statusService: statusService
  }));